import api from "./api";
import { Sponsor } from "../types";

export interface CreateSponsorRequest {
  name: string;
  logoUrl?: string;
}

export interface UpdateSponsorRequest {
  name?: string;
  logoUrl?: string;
}

export const sponsorService = {
  async getAllSponsors(): Promise<Sponsor[]> {
    const response = await api.get('/sponsors');
    return response.data;
  },

  async getSponsorsByAssociation(): Promise<Sponsor[]> {
    console.log('🔍 Frontend SponsorService - Buscando patrocinadores da associação');
    
    try {
      // 🛡️ CORREÇÃO: Usar endpoint direto /sponsors que já filtra por associação
      console.log('🌐 Frontend SponsorService - Fazendo requisição para: /sponsors');
      
      const response = await api.get('/sponsors');
      console.log('✅ Frontend SponsorService - Resposta recebida:', response.data);
      
      return response.data;
      
    } catch (error) {
      console.error('❌ Erro ao buscar patrocinadores da associação:', error);
      throw error;
    }
  },

  async getSponsorById(id: string): Promise<Sponsor> {
    const response = await api.get(`/sponsors/${id}`);
    return response.data;
  },

  async createSponsor(data: CreateSponsorRequest): Promise<Sponsor> {
    const response = await api.post('/sponsors', data);
    return response.data;
  },

  async updateSponsor(id: string, data: UpdateSponsorRequest): Promise<Sponsor> {
    const response = await api.put(`/sponsors/${id}`, data);
    return response.data;
  },

  async deleteSponsor(id: string): Promise<void> {
    await api.delete(`/sponsors/${id}`);
  }
};
